import React from 'react';

import { PERMISSIONS } from 'api/auth/constants';
import { IAuthState } from 'api/auth/types';
import { SESSION_KEYS } from 'queries/session/constants';
import { useQueryData } from 'queries/utils';

export enum PERMISSION_TYPE {
  AND = 'AND',
  OR = 'OR',
}

export interface ICheckPermissionProps {
  conditionType?: PERMISSION_TYPE;
  list?: PERMISSIONS[];
}

export type TCheckPermission = (props: ICheckPermissionProps) => boolean;

interface IRbacProps {
  conditionType?: PERMISSION_TYPE;
  list?: PERMISSIONS[];
}

export const useRBAC = ({ conditionType, list }: IRbacProps = {}) => {
  const session = useQueryData<IAuthState>([SESSION_KEYS.SESSION]);

  const checkPermission = React.useCallback(
    (
      { conditionType = PERMISSION_TYPE.AND, list = [] }: ICheckPermissionProps = {
        conditionType: PERMISSION_TYPE.AND,
        list: [],
      },
    ): boolean => {
      let permission: boolean | undefined = false;

      if (conditionType === PERMISSION_TYPE.AND) {
        permission = list?.every((userPermission) =>
          session?.permissions?.find((permissions) => permissions === userPermission),
        );
      }

      if (conditionType === PERMISSION_TYPE.OR) {
        permission = list?.some(
          (userPermission) =>
            !!session?.permissions?.find((permissions) => permissions === userPermission),
        );
      }
      return permission;
    },
    [session?.permissions],
  );

  const permissionExist = checkPermission({ conditionType, list });

  return {
    checkPermission,
    enabled: permissionExist,
    isFullAccess: !!session?.fullAccess,
  };
};
